import React from 'react';
import { FadeIn } from './FadeIn';
import { QuoteIcon } from 'lucide-react';
export function NewTestimonials() {
  const testimonials = [{
    name: 'Lucía',
    subtitle: '32 años · Endometriosis grado III',
    quote: 'Vivía hinchada como si estuviera embarazada de 4 meses todos los días. Al día 21 tenía vientre plano por primera vez en años.',
    chip: '60% menos analgésicos',
    img: 'https://cdn.magicpatterns.com/uploads/isMQE275ibEtfBUunbCo1x/TESTIMONIO_compressed_high.png'
  }, {
    name: 'Elena',
    subtitle: '34 años · Endo-belly severo',
    quote: 'Lo que más me sorprendió fue mi humor. Al final de la segunda semana mi dolor pélvico se había reducido a una molestia mínima.',
    chip: 'Dolor 8/10 → 2/10',
    img: 'https://cdn.magicpatterns.com/uploads/2PsjdhDaJdo9poUCpc5ZbQ/TESTIMONIO_1_compressed_high.png'
  }, {
    name: 'Mariana',
    subtitle: '29 años · Inflamación crónica',
    quote: 'Descubrí que el estrés inflamaba tanto como la comida. Ajusté mi sueño y mis martes de dolor se redujeron en un 60%.',
    chip: 'Energía estable todo el ciclo',
    img: 'https://cdn.magicpatterns.com/uploads/mu1DwDhnB3gRfLKUPhEkF1/Imagen_del_HERO.png' // Placeholder for 3rd avatar
  }];
  return <section className="py-12 md:py-24 bg-[#143F35]" data-id="element-456">
      <FadeIn className="container mx-auto px-5 max-w-[1200px]" data-id="element-457">
        <div className="max-w-3xl mb-10 md:mb-16" data-id="element-458">
          <span className="text-sand/60 text-xs font-bold tracking-[0.2em] uppercase mb-3 md:mb-4 block" data-id="element-459">
            Casos reales
          </span>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream mb-4 md:mb-6 leading-tight" data-id="element-460">
            Mujeres que recuperaron su vientre, su energía y su vida
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-461">
          {testimonials.map((t, idx) => <div key={idx} className="bg-[#1b2f28] p-6 md:p-10 rounded-2xl border border-cream/5 flex flex-col h-full shadow-lg" data-id="element-462">
              <QuoteIcon className="w-8 h-8 text-peach/60 mb-5 md:mb-6" data-id="element-463" />

              <p className="font-serif text-sand text-lg md:text-xl italic mb-6 md:mb-8 flex-grow leading-relaxed" data-id="element-464">
                "{t.quote}"
              </p>

              <div className="mb-8" data-id="element-465">
                <span className="inline-block bg-cream/5 text-sand/80 text-xs font-medium px-4 py-2 rounded-full border border-cream/10" data-id="element-466">
                  {t.chip}
                </span>
              </div>

              <div className="border-t border-cream/10 pt-6 flex items-center gap-4" data-id="element-467">
                <img src={t.img} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#1b2f28] shadow-md" data-id="element-468" />
                <div data-id="element-469">
                  <div className="font-serif text-xl text-cream mb-1" data-id="element-470">
                    {t.name}
                  </div>
                  <div className="text-sand/60 text-xs" data-id="element-471">{t.subtitle}</div>
                </div>
              </div>
            </div>)}
        </div>
      </FadeIn>
    </section>;
}